import { LucideIcon, Home, Briefcase, MessageSquare, Bot, Wand2, Calculator, Settings, Share2 } from "lucide-react";

export interface DocsSubcategory {
  id: string;
  title: string;
  description?: string;
}

export interface DocsCategory {
  id: string;
  title: string;
  icon: LucideIcon;
  description: string;
  subcategories: DocsSubcategory[];
}

export const DOCS_CATEGORIES: DocsCategory[] = [
  {
    id: "getting-started",
    title: "Início",
    icon: Home,
    description: "Primeiros passos com o Justiçai",
    subcategories: [
      { id: "welcome", title: "Bem-vindo ao Justiçai", description: "Visão geral da plataforma" },
      { id: "first-steps", title: "Primeiros Passos", description: "Como começar a usar" },
      { id: "interface", title: "Conhecendo a Interface", description: "Elementos da tela principal" },
      { id: "sidebar", title: "Entendendo a Sidebar", description: "Menu lateral e navegação" },
    ],
  },
  {
    id: "casos",
    title: "Casos / Clientes",
    icon: Briefcase,
    description: "Gerencie seus processos jurídicos",
    subcategories: [
      { id: "criar-caso", title: "Criar um Caso", description: "Como criar um novo caso" },
      { id: "editar-caso", title: "Editar um Caso", description: "Modificar informações do caso" },
      { id: "pastas", title: "Organizar em Pastas", description: "Criar e gerenciar pastas" },
      { id: "base-conhecimento", title: "Base de Conhecimento", description: "Upload de arquivos e PDFs" },
      { id: "chat-caso", title: "Chat do Caso com IA", description: "Conversar sobre o caso" },
      { id: "documentos", title: "Criar Documentos", description: "Gerar documentos jurídicos" },
      { id: "templates", title: "Usar Templates", description: "Modelos prontos de documentos" },
      { id: "historico-docs", title: "Histórico de Documentos", description: "Ver documentos anteriores" },
      { id: "compartilhar-caso", title: "Compartilhar Caso", description: "Compartilhar com colegas" },
    ],
  },
  {
    id: "chat-juridico",
    title: "Chat Jurídico",
    icon: MessageSquare,
    description: "Converse com a IA Laib 3.7",
    subcategories: [
      { id: "nova-conversa", title: "Iniciar Conversa", description: "Como começar uma conversa" },
      { id: "ferramentas-chat", title: "Ferramentas do Chat", description: "Opções disponíveis" },
      { id: "anexos", title: "Enviar Anexos", description: "Upload de arquivos no chat" },
      { id: "historico-chat", title: "Histórico de Conversas", description: "Ver conversas anteriores" },
    ],
  },
  {
    id: "assessor",
    title: "Assessor",
    icon: Bot,
    description: "Seu secretário virtual personalizado",
    subcategories: [
      { id: "o-que-e", title: "O que é o Assessor", description: "Entenda o Assessor" },
      { id: "configurar-assessor", title: "Configurar o Assessor", description: "Personalização completa" },
      { id: "escopo", title: "Definir Escopo de Acesso", description: "O que o assessor pode ver" },
      { id: "tom-resposta", title: "Tom de Resposta", description: "Estilo de comunicação" },
    ],
  },
  {
    id: "melhore-texto",
    title: "Melhore seu Texto",
    icon: Wand2,
    description: "Aprimore sua escrita jurídica",
    subcategories: [
      { id: "como-usar-melhoria", title: "Como Usar", description: "Passo a passo" },
      { id: "tipos-melhoria", title: "Tipos de Melhoria", description: "Opções disponíveis" },
    ],
  },
  {
    id: "calculos",
    title: "Cálculos Jurídicos",
    icon: Calculator,
    description: "Calculadoras para advogados",
    subcategories: [
      { id: "trabalhistas", title: "Cálculos Trabalhistas", description: "Rescisão, férias, horas extras" },
      { id: "inss", title: "Cálculos INSS", description: "Contribuições previdenciárias" },
      { id: "atualizacao", title: "Atualização de Valores", description: "Correção monetária" },
      { id: "pensao", title: "Pensão Alimentícia", description: "Cálculo de pensão" },
      { id: "aluguel", title: "Cálculos de Aluguel", description: "Reajustes e multas" },
      { id: "dosimetria", title: "Dosimetria de Pena", description: "Cálculo penal" },
    ],
  },
  {
    id: "configuracoes",
    title: "Configurações",
    icon: Settings,
    description: "Personalize sua conta",
    subcategories: [
      { id: "perfil", title: "Meu Perfil", description: "Dados pessoais e OAB" },
      { id: "planos", title: "Planos e Assinatura", description: "Gerenciar seu plano" },
      { id: "creditos", title: "Créditos e Armazenamento", description: "Comprar créditos extras" },
      { id: "papel-timbrado", title: "Papel Timbrado", description: "Configurar cabeçalho/rodapé" },
      { id: "tema", title: "Tema Claro/Escuro", description: "Aparência da plataforma" },
    ],
  },
  {
    id: "compartilhamento",
    title: "Compartilhamento",
    icon: Share2,
    description: "Trabalhe em equipe",
    subcategories: [
      { id: "como-compartilhar", title: "Compartilhar um Caso", description: "Enviar caso para colega" },
      { id: "grupos", title: "Criar Grupos", description: "Grupos de trabalho" },
      { id: "permissoes", title: "Gerenciar Permissões", description: "Níveis de acesso" },
    ],
  },
];

export const getCategoryById = (id: string): DocsCategory | undefined => {
  return DOCS_CATEGORIES.find(cat => cat.id === id);
};

export const getSubcategoryById = (categoryId: string, subcategoryId: string): DocsSubcategory | undefined => {
  const category = getCategoryById(categoryId);
  return category?.subcategories.find(sub => sub.id === subcategoryId);
};
